module.exports = __webpack_public_path__ + "static/media/arrow-left-dark.6ed0c19d.png";